import api from './api';

export const profileService = {
  getAllProfiles: async (params = {}) => {
    const response = await api.get('/profiles', { params });
    return response.data;
  },

  getProfile: async (id) => {
    const response = await api.get(`/profiles/${id}`);
    return response.data;
  },

  createProfile: async (data) => {
    const response = await api.post('/profiles', data);
    return response.data;
  },

  updateProfile: async (id, data) => {
    const response = await api.put(`/profiles/${id}`, data);
    return response.data;
  },
  
  uploadResume: async (id, formData) => {
    const response = await api.post(`/profiles/${id}/resume`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  deleteProfile: async (id) => {
    const response = await api.delete(`/profiles/${id}`);
    return response.data;
  },

  getProfileSkills: async (id) => {
    const response = await api.get(`/profiles/${id}/skills`);
    return response.data;
  },

  addSkillToProfile: async (id, skillData) => {
    const response = await api.post(`/profiles/${id}/skills`, skillData);
    return response.data;
  },

  updateProfileSkill: async (profileId, skillId, skillData) => {
    const response = await api.put(`/profiles/${profileId}/skills/${skillId}`, skillData);
    return response.data;
  },

  removeSkillFromProfile: async (profileId, skillId) => {
    const response = await api.delete(`/profiles/${profileId}/skills/${skillId}`);
    return response.data;
  },

  generateCV: async (id, format = 'html') => {
    // Open CV in new tab (backend generates HTML)
    const token = sessionStorage.getItem('token');
    const url = `/api/profiles/${id}/cv?token=${token}`;
    window.open(url, '_blank');
    return { success: true };
  }
};
